import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetAccessSociogramTeachers = (termId) => {
  const query = useApiQuery(
    ['sociogramteachers', termId],
    'schools',
    `/current-organization/current-term/sociogram-teachers?termId=${termId}&accessState=all`,
    { enabled: !!termId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoadingSociogramTeachers: query.isLoading || query.isFetching,
    dataSociogramTeachers: query.data ?? null,
    errorSociogramTeachers: query.isError ? query.error : null,
    getSociogramTeachers: query.refetch
  }
}
